import { Component, SimpleChanges, ChangeDetectorRef, ViewChild, ElementRef, Inject, PLATFORM_ID, HostListener, HostBinding } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators, UntypedFormControl, UntypedFormArray, FormGroup, FormArray } from '@angular/forms';
import { Observable, Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { PaginationModel } from '@framework/models/pagination-models';
import { CoreState } from '@app/store/core/states';
import { ScrollbarComponent } from '@framework/components';
import { storyBuilderSelector } from '@modules/story/store/selectors';
import { UtilityHelper } from '@framework/utilities';
import { StoryOutputApiModel } from '@modules/story/models/api-models/output';
import { UserViewModel, UserProfileViewModel } from '@modules/user/store/models';
import { LoadUserInputApiModel } from '@modules/user/models/input/load-user-input.api-model';
import { userSelectors, userProfileSelectors } from '@modules/user/store/selectors';
import { userActions, userPermissionActions } from '@modules/user/store/actions';
import { campaignSelectors, companySelectors } from '@modules/company/store/selectors';
import { CampaignViewModel, CompanyViewModel } from '@modules/company/models/store-view-models';
import { Actions, ofType } from '@ngrx/effects';
import { ValidateUserOutApiModel } from '@modules/user/models/output';
import { ComponentModalBase } from '@framework/base';
import { ModalService, ToastService, UploaderService, LoadingPopupService } from '@framework/services';
import { isString } from 'ts-util-is';
import { RequestInputApiModel } from '@modules/shared/models/api-models/input';
import { campaignActions } from '@modules/company/store/actions';
import { GetCampaignInputApiModel } from '@modules/company/models/api-models/input';
import { CommentHttpService } from '@modules/shared/services';
import { RequestStoryStoreScope, RequestStoryStoreSnapshot } from '@modules/shared/services/request-story-store-scope.service';
import { Router } from '@angular/router';
import { storyAction, storyBuilderActions, storyStepActions } from '@modules/story/store/actions';
import * as _ from 'lodash';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { CreateTagsModalComponent } from '@modules/company-admin/components/create-tags-modal';
import { mediaActions, mediaDownloadAction, mediaRecordAction } from '@app/store/features/media/actions';
import { StoryFlowMenuItemViewModel } from '@modules/story/models/view-models';
import { Constants } from '@modules/shared/constants';
import { CreateMediaInputApiModel } from '@app/store/http/models/input';
import { companyLanguagesActions, emailCustomizeSettingAction, storyActions } from '@modules/company-admin/store/actions';
import { VideoRecorderMediaComponent } from '@modules/story/components';
import { StoryHttpService } from '@modules/company-admin/store/services';
import { isPlatformBrowser } from '@angular/common';
import { RequestVideoRecorderMediaComponent } from '../../request-video-recorder-media';
import { ConfirmationModalComponent } from '../../commons/confirmation-modal';
import { promptAppliesToGuests, promptAppliesToUsers } from '@modules/shared/utils/prompt-audience.util';
declare var $:any
@Component({
  selector: 'app-request-story',
  templateUrl: './request-story.component.html',
  styleUrls: ['./request-story.component.scss'],
  animations: [
    trigger('showhide', [
      // ...
      state('show', style({
        opacity: 1,
        zIndex: 9
      })),
      state('hide', style({
        opacity: 0,
        zIndex: -1
      })),
      transition('show => hide', [
        animate('0.5s ease-in-out')
      ]),
      transition('hide => show', [
        animate('0.5s ease-in-out')
      ]),
    ]),
    trigger('showhideadthis', [
      // ...
      state('show', style({
        opacity: 1,
        zIndex: 1000
      })),
      state('hide', style({
        opacity: 0,
        zIndex: -1
      })),
      transition('show => hide', [
        animate('0.5s ease-in-out')
      ]),
      transition('hide => show', [
        animate('0.5s ease-in-out')
      ]),
    ]),
  ]
})
export class RequestStoryComponent extends ComponentModalBase<any> {
  @ViewChild("shareholic") shareholic: ElementRef;
  @ViewChild('videoPlayer') videoPlayer!: ElementRef<HTMLVideoElement>;
  @ViewChild('greetingVideoInput') greetingVideoInput!: ElementRef<HTMLInputElement>;
  public isBrowser:boolean;
  private getMembers$: Observable<UserViewModel[]>;
  // From a User / From a Guest fade-through: the pill follows pendingUserStatus
  // right away while the panel swap happens behind the faded-out content
  public userTabSwapping = false;
  public pendingUserStatus: 'user' | 'Guestuser';
  private userTabSwapTimer: any;
  private getNextUrl$: Observable<string>;
  public storyParam:any = 'What happenn?'
  public companyId:any;
  public isshowTag:boolean = false;
  public isShowmedia:boolean = false;
  /** Modal X + collapse-tab accent: white on Add Media, else active menu icon color. */
  public panelCloseColor: string = '#ffffff';
  /** Host class so gallery can sit full-height beside the sticky header. */
  @HostBinding('class.rs-panel-open')
  get rsPanelOpen(): boolean {
    return !!this.isShowModal;
  }
  get isPanelCloseWhite(): boolean {
    const c = (this.panelCloseColor || '').toLowerCase();
    return c === '#fff' || c === '#ffffff' || c === 'white';
  }
  public menu;
  public showemailSection: boolean = false;
  public inbound:boolean = false;
  public question_text:any;
  public question_clicked:boolean = false;
  public createQuestionSuccessSubscription: Subscription;
  private selectPlayerLoading$: Observable<boolean>;
  private selectPlayerLoaded$: Observable<boolean>;
  public interviewStyle:boolean = false;
  private selectCurrentCompany$: Observable<CompanyViewModel>;
  private selectCurrentProfile$: Observable<UserProfileViewModel>;
  public upatedCampaignList:any;
  public showRequestedUser:boolean = false;
  public showAuthorDropdown: boolean = false;
  public isMediaIncluded:boolean  = true;
  public loggedInUserId:any;
  public internalQuestionId:any;
  public externalquestionid:any;
  private formChangeSubscription: Subscription;
  private inviteFormchange: Subscription;
  private getNextUrlSubscription: Subscription;
  private selectPlayerLoadingSubscription: Subscription;
  private selectPlayerLoadedSubscription: Subscription;
  private getMembersSubscription: Subscription;
  private selectCurrentCompanySubscription: Subscription;
  private selectCurrentProfileSubscription: Subscription;
  private validateUserSuccessSubscription: Subscription;
  private selcetFormSubscription: Subscription;
  public selectEmailCustomizeListSubscription: Subscription;
  private loadPermissionSuccessSubscription: Subscription;
  private loadStepSuccessSubscription:Subscription;
  private loadQuestionsSubscription: Subscription;  
  private videoChunkUploading: Subscription;

  private loadUserInputData: LoadUserInputApiModel = new LoadUserInputApiModel(new PaginationModel(1000));
  private isPlayerAdding: boolean = false;
  public videoCurrentUrl:any;
  public isShowPromptContainer: boolean = false;
  public isShowModal:boolean = false;
  public members: any = [];
  public isRequest: boolean = false;
  public newMembers: any = [];
  public requestedMembers: any[] = [];
  public questionList:any[] = [];
  public searchBarVisible: boolean = false;
  public requestedUsers: any[] = []
  public isCopyCode: boolean = false
  public readOnlyforTextfiled: boolean = false;
  public isSingleInternalRequested:boolean = false;
  public hideSendanCopylinkButton: boolean = false;
  public emailSendIngPayload:any [] = [];
  public externalUrlforCopy:string;
  public InternalStorySingleUrl:string;
  public userQuestion: any[] = [];
  public guestquestion: any[] = [];
  public buttonText: string = 'Copy'
  public isDispalyMenu: boolean = false
  public isDispalyadthis: boolean = false
  public uploaderInstance;
  public sendInternalmail:boolean = false;
  public uploaderViewModel: any = {
    errorMsg: 'An error occurred while uploading.',
    isError: false,
    progress: 0,
    progressCss: '0%',
    isUploading: false
  };
  public uploadedId:any[] = [];
  public showelipse:boolean= false;
  private greetingMuxUploaderBound = false;
  private pendingGreetingUploadId: string;
  public requested_sender:any;
  public viewmodel: any = {
    scrollbarVisible: false,
    reachStarted: false,
    reachEnded: false,
    firstLoad: true,
    lastPosition: null,
    fetch: false,
    searching: false,
    isStoryCreating: false,
    isStoryUpdating: false,
    isPlayerCreating: false,
    isPlayerLoading: false,
    isPlayerLoaded: false,
    isInboundCampaign: false,
    //loadingDataOnScroll: false
  };
  public form: UntypedFormGroup;
  public addPlayerForm: UntypedFormGroup;
  public requestForm: UntypedFormGroup;
  public loadMore: boolean = true;
  public stepActive: any;
  public selectedData: any = [];
  public storyData: StoryOutputApiModel;
  public isFormSubmited: boolean = false;
  public companyLogo: string;
  public company: CompanyViewModel;
  public isNoOneSpecific: boolean = false;
  public isShowNoOneSpecific: boolean = false;
  public isHideErrorEmailInput: boolean = true;
  public diableonsearching: boolean = false;
  public isLoading: boolean = false;
  public campaigns: CampaignViewModel[] = [];
  public questionModels:any[] = [];
  public mediaIndex:any;
  // Kept even when the media step is off, so the gallery panel learns the
  // gallery is turned off and shows that message.
  public mediaStep: any = null;
  public username:any;
  public showEditor: boolean = false;
  public camapignqueston: any[] = [];
  public externalCampaignQuestion: any[] = [];
  public addQuestion:boolean = false;
  public is_not_other_email:boolean = false;  public primary_color:any;
  public secondary_button_color:any;
  public dataUrl:any;
  public show_video = false;
  public showEmailEditor:boolean = false;
  public is_video = false;
  public greetingReady = false;
  public asset_id:any;
  public videoAccepted: boolean = false;
  public allmails:any;
  public loadDataSubscription: Subscription;
  public dynamicObject:any;
  
  // Tabbed interface properties
  public activePromptTab: 'single' | 'campaign' = 'campaign';
  
  // People selection properties (for compilation)
  public selectedPeopleIds: any[] = [];
  public searchResultsCount: number | null = null;
  public requestLinksQuery: string = '';
  public showAllRequestLinks: boolean = false;
  
  public isDropdownFocused: boolean = false;
  public isDropdownTyping: boolean = false;
  private loadColorSuccessSubscription: Subscription;
  private selectCampaign$: Observable<CampaignViewModel[]>;
  private selectCampaignSubscription: Subscription;
  private queryCampaignsData: GetCampaignInputApiModel = new GetCampaignInputApiModel(new PaginationModel(1000));

  @ViewChild('scrollbar')
  scrollbar: ScrollbarComponent;
  isSmallScreen: boolean;
  disableSubmit: boolean;

  get requestGalleryCampaignId(): number | null {
    if (!this.requestForm || this.activePromptTab !== 'campaign') {
      return null;
    }
    const raw = this.requestForm.value?.userStatus === 'Guestuser'
      ? this.requestForm.value.externalcampaign
      : this.requestForm.value.campaign;
    const id = Number(raw);
    if (!id || id <= 0 || isNaN(id)) {
      return null;
    }
    return id;
  }

  get isGreetingVideoPending(): boolean {
    return !!this.is_video && !this.asset_id;
  }

  public isGreetingRecordingOpen = false;

  get tagsSelectedCount(): number {
    if (!this.dynamicObject) return 0;
    return Object.keys(this.dynamicObject).reduce((total, key) => {
      if (+key === 16) return total;
      const val = this.dynamicObject[key];
      return total + (Array.isArray(val) ? val.length : 0);
    }, 0);
  }

  get mediaSelectedCount(): number {
    if (!this.dynamicObject) return 0;
    const media = this.dynamicObject[16];
    return Array.isArray(media) ? media.length : 0;
  }

  get greetingSelectedCount(): number {
    return this.is_video ? 1 : 0;
  }

  get hasTagsSelected(): boolean {
    return this.tagsSelectedCount > 0;
  }

  get hasMediaSelected(): boolean {
    return this.mediaSelectedCount > 0;
  }

  get isGreetingOpen(): boolean {
    return this.isGreetingRecordingOpen || (!!this.isDispalyMenu && !!this.show_video);
  }

  get isTagsOpen(): boolean {
    return !!this.isShowModal && !!this.isshowTag;
  }

  get isMediaOpen(): boolean {
    return !!this.isShowModal && !!this.isShowmedia;
  }

  mediaSubscription: Subscription;
  internalUrl: boolean = false;
  selectedLanguages:any[];
  /** Story state of the page behind this modal, put back on close. */
  private storeSnapshot: RequestStoryStoreSnapshot = null;
  constructor(
    private formBuilder: UntypedFormBuilder,
    private store$: Store<CoreState>,
    private detector: ChangeDetectorRef,
    private actions$: Actions,
    private utility: UtilityHelper,
    private cdref: ChangeDetectorRef,
    private modalService: ModalService,
    private router: Router,
    @Inject(PLATFORM_ID) platformId: Object,
    private actions: Actions,
    private toastService: ToastService,
    private requestService: CommentHttpService,
     private storyHttpService: StoryHttpService,
    private storeScope: RequestStoryStoreScope,
  ) {
    super();
    this.isBrowser = isPlatformBrowser(platformId);

    this.getMembers$ = this.store$.select(userSelectors.selectUsers);
    this.getNextUrl$ = this.store$.select(userSelectors.selectNextUrl);
    this.selectPlayerLoading$ = this.store$.select(userSelectors.selectLoading);
    this.selectPlayerLoaded$ = this.store$.select(userSelectors.selectLoaded);
    this.selectCurrentCompany$ = this.store$.select(companySelectors.selectSelectedCompany);
    this.selectCurrentProfile$ = this.store$.select(userProfileSelectors.selectCurrentProfile);
    this.selectCampaign$ = this.store$.select(campaignSelectors.selectAll);

    this.initForm();
  }

  private initForm() {
    if(!this.isBrowser) return;
    this.form = this.formBuilder.group({
      keyword: ['']
    });


    this.requestForm = this.formBuilder.group({
      about: [''],
      bodyCode: [{ value: '', disabled: true }],
      content:[{value: '', disabled: true}],
      campaign: [-1],
      note_email:['', Validators.required],
      externalcampaign: [-1],
      userselcted: [null],
      emailTemplate:[],
      emailSubject:[],
      emailSendername:[],
      externalUserSelcted: [null],
      requestedUser: [''],
      internalmessage: [''],
      firstname:[''],
      lastname: [''],
      message: [''],
      email: [''],
      languageSelected:['en'],
      question:[-1],
      externalquestion:[-1],
      userStatus:['user'],
      users: this.formBuilder.array([this.createUserGroup()]) ,
      addPersonalize:[false],
    });

    this.addPlayerForm = this.formBuilder.group({
      players: this.formBuilder.array([this.createAddPlayerItemForm()])
    });
  }

  private createAddPlayerItemForm() {
    if(!this.isBrowser) return;
    return this.formBuilder.group({
      firstName: ['', Validators.required],
      email: ['', Validators.compose([this.emailValidator.bind(this), Validators.email])]
    });
  }
  createUserGroup(): FormGroup {
    return this.formBuilder.group({
      firstName: ['', Validators.required],
      author_email: ['', [Validators.email,Validators.required]]
    });
  }

  get users(): FormArray {
    return this.requestForm.get('users') as FormArray;
  }
  addUser(): void {
    this.users.push(this.createUserGroup());
  }
  
  removeUser(index: number): void {
    if (this.users.length > 1) {
      this.users.removeAt(index);
    }
  }

  get lastUserValid(): boolean {
    const usersArray = this.users;
    const last = usersArray.at(usersArray.length - 1);
    return last?.valid ?? false;
  }
  protected onInit(): void {
    if(this.isBrowser){
      navigator.mediaDevices
      .getUserMedia({ audio: true,  video: {
        width: { ideal: 1280 },
        height: { ideal: 720 },
        frameRate: { ideal: 30, max: 30 }
      } })
      .then((stream)=>{
        stream.getTracks().forEach(track => track.stop());
      })
    }

    this.selectedLanguages = this.getLanguagesFromStorage()

    if (this.isBrowser) {
      this.storeSnapshot = this.storeScope.enter();
    }
    if (this.isSinglePromptRequest()) {
      this.activePromptTab = 'single';
    }
    this.subscribe();
  }

  getLanguagesFromStorage(): any[] {
    const data = localStorage.getItem('languages');
    return data ? JSON.parse(data) : [];
  }

  protected onDestroy(): void {
    if(!this.isBrowser) return;
    // Restore first so picks never leak into the next modal or Submit Story.
    this.storeScope.leave(this.storeSnapshot);
    this.unSubscribe();
  }

  protected onChanges(changes: SimpleChanges): void {
    if(!this.isBrowser) return;

  }
  protected onDoCheck(): void {

  }
  protected onAfterContentInit(): void {
    // if(typeof (<any>window).addthis !== 'undefined') { (<any>window).addthis.layers.refresh(); }

  }
  protected onAfterContentChecked(): void {
  }
  protected onAfterViewInit(): void {
    // $(document).on('click','#cancel-request-btn',function(event){
    //   close()
    // })
    if(!this.isBrowser) return;
    setTimeout(()=>{
     this.showEditor = true;
    },6000)
  }

  protected onAfterViewChecked(): void {
    if(!this.isBrowser) return;
  }

  private subscribe() {
    if(!this.isBrowser) return;
   this.inviteFormchange = this.requestForm.valueChanges.pipe(
    debounceTime(100)
  ).subscribe((value) => {

    // if(this.hideSendanCopylinkButton && this.isSingleInternalRequested){
    //   this.hideSendanCopylinkButton  = false;
    //   this.isSingleInternalRequested = false;
    // }

    if(this.externalUrlforCopy && !this.showemailSection){
      this.isSingleInternalRequested = false;
    }

    // After links exist, any form edit clears them so Create Link regenerates unique URLs.
    if (this.isCopyCode && !this.sendInternalmail) {
      this.invalidateCreatedRequestLinks();
      return;
    }

    if(this.internalUrl && !this.sendInternalmail){
      this.hideSendanCopylinkButton = false;
    }

  })

  this.videoChunkUploading = this.actions$.pipe(
    ofType<mediaActions.GetVideochunks>(mediaActions.ActionTypes.GET_VIDEO_CHUNKS)
  ).subscribe((action) =>{
    this.videoCurrentUrl = action.file;
    this.commonUploadFuctionality();
  })

  this.loadStepSuccessSubscription = this.actions$.pipe(
    ofType<storyBuilderActions.UpdateStoryStepSelected>(storyBuilderActions.StoryBuilderActionTypes.UPDATE_STORY_STEP_SELECTED)
  ).subscribe((result) => {
    if(result){
       console.log("result",result)
    }})

  this.loadStepSuccessSubscription = this.actions$.pipe(
    ofType<storyStepActions.LoadSuccess>(storyStepActions.ActionTypes.LOAD_SUCCESS)
  ).subscribe((result) => {
    if(result){
      this.stepActive = result.data.filter( stp => stp.id != 17  && stp.id != 5 && stp.is_active != 0) ;
            this.menu =  result.data.filter(stp => stp.id != 17 && stp.id != 16 && stp.id != 5 && stp.is_active != 0).map(r => {
                const menuItem = new StoryFlowMenuItemViewModel();
                menuItem.id = r.id;
                menuItem.title = r.title;
                menuItem.icon = Constants.stepIcon.getStepIcon(this.istitle(r.id).replace(/\s+/gi, ''));
                menuItem.color = r.color;
                return menuItem;
            });
            this.mediaIndex = this.stepActive.findIndex(menu => menu.id == 16)
            this.mediaStep = result.data.find(stp => stp.id == 16) || null;
            // Add Media / Add Tags clicked before the steps arrived sent no step,
            // so the gallery assumed galleries were off and showed the flat list.
            this.syncOpenPanelStep();
    }

  })

  this.loadDataSubscription = this.actions$.pipe(
    ofType<storyStepActions.AddToObject>(storyStepActions.ActionTypes.ADD_TO_OBJECT) // listen for the action
  ).subscribe((action: any) => {
    
    // If key doesn't exist, create it

   this.dynamicObject = {
      ...this.dynamicObject,   // keep existing keys
      ...action.value          // add/overwrite new keys
    };

    if(this.externalUrlforCopy){
      this.isSingleInternalRequested = false;
    }

    if (this.isCopyCode) {
      this.invalidateCreatedRequestLinks();
    } else if (this.internalUrl) {
      this.hideSendanCopylinkButton = false;
    }
  
    // console.log('Merged dynamicObject in Component B:', this.dynamicObject);
  });
  
  this.loadDataSubscription = this.actions$.pipe(
    ofType<storyStepActions.AddMediaObject>(storyStepActions.ActionTypes.ADD_MEDIA_TO_OBJECT) // listen for the action
  ).subscribe((action: any) => {
    
    // If key doesn't exist, create it

    this.dynamicObject = {
      ...this.dynamicObject,   // keep existing keys
      ...action.value          // add/overwrite new keys
    };
    if(this.externalUrlforCopy){
      this.isSingleInternalRequested = false;
    }

    if (this.isShowmedia) {
      return;
    }

    if (this.isCopyCode) {
      this.invalidateCreatedRequestLinks();
    } else if (this.internalUrl) {
      this.hideSendanCopylinkButton = false;
    }
  
    // console.log('Merged dynamicObject in Component B:', this.dynamicObject);
  });

  this.createQuestionSuccessSubscription = this.actions$.pipe(
    ofType<storyStepActions.CreateQuestionSuccess>(storyStepActions.ActionTypes.CREATE_QUESTION_SUCCESS)
  ).subscribe((data) => {
    if(data.response && data.response?.is_active == 1){
        if(data.response.inbound){
          this.inbound = true;
          this.question_text = data.response.question_text;
        }
        else{
          this.inbound = false;
          this.question_text = data.response.question_text;
        }
    }
    else{
      this.question_clicked = false;
    }
  });


  this.loadPermissionSuccessSubscription =  this.actions$.pipe(
    ofType<userPermissionActions.LoadPermissionsSuccess>(userPermissionActions.ActionTypes.LOAD_PERMISSION_SUCCESS)
  ).subscribe((action: any) => {
   if(action.response && action.response.length){
    this.showRequestedUser = action.response.find(permission => permission.name === 'requested_user_details');
   }
  })

    this.formChangeSubscription = this.form.controls['keyword'].valueChanges.pipe(
      debounceTime(900)
    ).subscribe((value) => {
      this.viewmodel.searching = true;
      this.loadUserInputData.search = value && value.trim() || '';
      this.loadUserInputData.pagination.page = 1;
      this.loadUserInputData.pagination.sort = 'desc'

      // this.scrollbar.scrollToTop(0);
      if (this.loadUserInputData.search.length === 0) {
        this.diableonsearching = false;
        this.resetSearchForm();
      } else {
        this.diableonsearching = true;
        this.loadMembers([]);
      }
    });

    this.selectCampaignSubscription = this.selectCampaign$.subscribe((campaigns) => {
      if (!campaigns?.length) {
        return;
      }
      this.campaigns = campaigns.filter(camp => camp.daysLeft > 0) || [];
      const nonCampaign = {
        id: -1,
        title: 'Select option',
        queryObjects: null,
        buttons: null,
        slug: null,
        headerImage: null,
        avatarImage: null,
        person: null,
        description: null,
        start_date: null,
        end_date: null,
        companySlug: null,
        isInboundStoriesEnabled: null,
        isPublic: null,
        stories: null,
        daysLeft: null,
        storyPrompt: null,
        show_story_prompt: 0
      };
      if (!this.campaigns.some(c => c.id === -1)) {
        this.campaigns.unshift(nonCampaign);
      }
      this.detector.detectChanges();
    });

    this.getNextUrlSubscription = this.getNextUrl$.subscribe((nextUrl) => {
      this.loadMore = nextUrl !== null;
    });

    this.selectPlayerLoadingSubscription = this.selectPlayerLoading$.subscribe((isLoading: boolean) => {
      this.viewmodel.isPlayerLoading = isLoading;
    });

    this.selectPlayerLoadedSubscription = this.selectPlayerLoaded$.subscribe((isLoaded: boolean) => {
      this.viewmodel.isPlayerLoaded = isLoaded;
    });

    this.selectCurrentCompanySubscription = this.selectCurrentCompany$.subscribe((company) => {
      if (company) {
        this.companyLogo = company.logo;
        this.company = company;
        this.is_not_other_email = this.isEmailDomainAllowed(this.requesterEmail(), company.domains)
        if(!this.is_not_other_email){
          this.requestForm.controls.emailSendername.setValue(this.company?.requested_from_name)
        }
        this.store$.dispatch(new storyActions.GetColor(this.company.id));
      }
    });
    this.loadColorSuccessSubscription = this.actions$.pipe(
      ofType<storyActions.GetColorSuccess>(storyActions.ActionTypes.GET_BUTTON_COLOR_SUCCESS)
    ).subscribe((action: any) => {
      if(action && action.response && action.response && action.response.length){
        this.primary_color = action.response.find(item => item.button == 11).color;
        this.secondary_button_color = action.response.find(item => item.button == 8)?.color;
       }
      

    })

    this.getMembersSubscription = this.actions$.pipe(
      ofType<userActions.LoadSuccess>(userActions.ActionTypes.LOAD_SUCCESS)).
        subscribe((members) => {
      this.viewmodel.searching = false;
     // this.viewmodel.loadingDataOnScroll = false;
     
     
      this.viewmodel.isInboundCampaign = (this.viewmodel.inbound && this.company.isCampaignCompany);
      if (!this.viewmodel.isInboundCampaign) {
         this.members = members.response && members.response.result && members.response.result.length ? members.response.result : [];
         this.requestedMembers = this.members.map((member)=>{
          return {
            title:member.display_name,
            id:member.id
          }
         })
        
         if(this.requestedMembers.length && this.loggedInUserId){
          let loggedIn ={
            title:this.username,
            id:this.loggedInUserId
          }
          this.requestedMembers.unshift(loggedIn)
        }
      }
       this.updateSelectedValues();
    });
    this.mediaSubscription = this.actions$.pipe(
      ofType<mediaDownloadAction.CheckDownloaf>(mediaDownloadAction.ActionTypes.CHECK_DOWNLOAD)
    ).subscribe((action: any) => {
        if(action.download){
          this.disableSubmit = true;
        }
        else{
          this.disableSubmit = false;
        }
      

    })
    this.selectCurrentProfileSubscription = this.selectCurrentProfile$.subscribe((userProfile) => {
      if (userProfile) {
        this.companyLogo = userProfile.company.logo;
        this.companyId = userProfile.company.id;
       // this.store$.dispatch(new storyStepActions.LoadPlayerStep( this.companyId, false));
        this.store$.dispatch(new storyBuilderActions.SetInbound(false));
        this.store$.dispatch(new storyBuilderActions.SetCompanyId(this.companyId));
        // this.store$.dispatch(new storyStepActions.Load(this.companyId, false, '', true));
        this.store$.dispatch(new storyStepActions.Load(this.companyId, false, '', false));
        this.loggedInUserId = userProfile.id;
        this.username = userProfile.displayName
        this.viewmodel.inbound = false;
        this.viewmodel.companyId = userProfile.company.id;
        this.selectedData = [];
           this.store$.dispatch(new emailCustomizeSettingAction.Load(this.companyId));
        this.playersFormArray.controls.forEach((fgItem: UntypedFormGroup) => {
          fgItem.controls.email.updateValueAndValidity();
        });
        this.store$.dispatch(new storyStepActions.LoadQuestions(userProfile.company.id))
        this.updateSelectedValues();
        this.updateSelectedNoOneSpecific();
        this.loadMembers(this.selectedData);
        this.queryCampaignsData.isLoadExpired = false;
        this.queryCampaignsData.pagination.sort = 'desc';
        this.queryCampaignsData.isIncludeStories = true;
        this.queryCampaignsData.public = false;
        this.queryCampaignsData.pagination.limit = 100;
        this.store$.dispatch(new userPermissionActions.LoadPermissions());
        this.store$.dispatch(new campaignActions.Load(userProfile.company.id, this.queryCampaignsData));
        this.applySinglePromptOpenState();
      }
    });

        this.selectEmailCustomizeListSubscription = this.actions$.pipe(
          ofType<emailCustomizeSettingAction.LoadSuccess>(emailCustomizeSettingAction.ActionTypes.LOAD_SUCCESS)
        ).subscribe((result: any) => {
          if (result && result.response && result.response.length) {
              this.allmails = result.response;
              if(this.requestForm.value.userStatus == 'Guestuser'){
                this.requestForm.controls.emailTemplate.setValue(this.allmails.find(email => email.title === 'TO A USER - when some requests a story from them').body);
                this.requestForm.controls.emailSubject.setValue(this.allmails.find(email => email.title === 'TO A USER - when some requests a story from them').subject);
              }
              else{
                this.requestForm.controls.emailTemplate.setValue(this.allmails.find(email => email.title === 'TO A USER - when some requests a story from them').body);
                this.requestForm.controls.emailSubject.setValue(this.allmails.find(email => email.title === 'TO A USER - when some requests a story from them').subject);
              }
          }
        });

    this.validateUserSuccessSubscription = this.actions.pipe(
      ofType<userActions.ValidateUserSuccess>(userActions.ActionTypes.VALIDATE_USER_SUCCESS)
    ).subscribe((action: userActions.ValidateUserSuccess) => {
      this.validateUsersSuccess(action.response);
    });
    this.loadQuestionsSubscription = this.actions$.pipe(
      ofType<storyStepActions.LoadQuestionsSuccess>(storyStepActions.ActionTypes.LOAD_QUESTIONS_SUCCESS)).
        subscribe((questions: any) => {
         if(questions && questions.data && questions.data && questions.data.length){
          this.questionList= questions.data.filter(question => question.is_active == 1);
          if(this.questionList.length){
            const nonQuestion = {
              id:-1,
              is_active:null,
              question_text: 'Select option'

            }
            this.userQuestion = this.questionList.filter(item => promptAppliesToUsers(item) && item.is_active == 1);
            this.guestquestion = this.questionList.filter(item => promptAppliesToGuests(item) && item.is_active == 1);
            this.userQuestion.unshift(nonQuestion);
            this.guestquestion.unshift(nonQuestion)
            if(this.question_clicked){
              if(this.inbound){
                let Edata = this.questionList.find(item => item.question_text == this.question_text).id
                this.requestForm.controls.about.setValue(this.question_text)
                this.externalquestionid = +Edata
                this.isShowPromptContainer = true;
                this.requestForm.controls.content.setValue(this.requestForm.value.about);
                this.readOnlyforTextfiled = false;
                this.requestForm.controls.externalquestion.setValue(+Edata);
                this.requestForm.controls.externalcampaign.reset();
                this.requestForm.controls.externalcampaign.setValue(-1);
              }
              else{
                let Idata = this.questionList.find(item => item.question_text == this.question_text).id
                this.requestForm.controls.about.setValue(this.question_text)
                this.internalQuestionId = +Idata;
                this.isShowPromptContainer = true;
                this.requestForm.controls.content.setValue(this.requestForm.value.about);
                this.readOnlyforTextfiled = false;
                this.requestForm.controls.question.setValue(+Idata);
                this.requestForm.controls.campaign.reset();
                this.requestForm.controls.campaign.setValue(-1);
              }
            } else {
              this.applyLockedSinglePrompt(true);
            }

          }

         }
      })

    this.selcetFormSubscription = this.requestForm.controls.requestedUser.valueChanges.subscribe((data: any) => {
      this.requestForm.controls.bodyCode.setValue(data)
    })

  }


  istitle(id): string{
    if(!this.isBrowser) return;
    var path = ''
    switch (id) {
      case 2:
        path = 'Teams';
        break;

      case 5:
        path = 'People';
        break;

      case 8:
        path = 'Skills';
        break;

      case 11:
        path = 'Challenges';
        break;
      case 13:
        path = 'Vibes';
        break;

      case 14:
        path = 'Values';
        break;

      case 16:
        path = 'Media';
        break;

    }
    return path
  }
  isEmailDomainAllowed(email, domains) {
    if (!email || !email.includes("@")) return false;
  
    const emailDomain = email.split("@")[1].toLowerCase();
    return domains.some(d => d.domain.toLowerCase() === emailDomain);
  }
  chnageExternaladdPersonalize(data){
    if(!this.isBrowser) return;
    // this.requestForm.controls.firstname.reset();
    // this.requestForm.controls.lastname.reset();
    // this.requestForm.controls.email.reset();
    this.externalUrlforCopy = '';
    this.isSingleInternalRequested = false;
    this.emailSendIngPayload = [];
    this.hideSendanCopylinkButton = false;
    if(this.requestForm.value.addPersonalize){
     this.requestForm.get('message').updateValueAndValidity();
     this.requestForm.get('message').setValidators([Validators.required]);
    }
    else{
      this.requestForm.get('message').updateValueAndValidity();
      this.requestForm.get('message').clearValidators();
     this.Chnageuserstatus(null)
    }
   }

  Chnageuserstatus(data, keepMedia: number[] = [], keepTagSteps: { [stepId: number]: number[] } = {}){
  // Keep greeting across User/Guest (same as media). Do not call removeVideo().
  // Clear other picks but keep company id + carried media/tags: a full store
  // reset left the gallery on company 0, which the API serves as GoodSeeker stock.
  this.storeScope.clearSelections(
    this.companyId,
    this.requestForm.value.userStatus == 'Guestuser',
    keepMedia,
    keepTagSteps
  );
  this.dynamicObject = {};
  if (keepMedia.length) {
    this.dynamicObject[Constants.storyStep.media] = [...keepMedia];
  }
  Object.keys(keepTagSteps || {}).forEach((stepId) => {
    const ids = keepTagSteps[stepId];
    if (ids && ids.length) {
      this.dynamicObject[stepId] = [...ids];
    }
  });
  this.isShowModal = false;
  this.resetModalWidth();
  this.internalUrl = false;
  this.sendInternalmail = false;
  this.showAuthorDropdown = false;
    if(this.requestForm.value.userStatus == 'Guestuser'  &&  !this.isSingleInternalRequested){
       this.requestForm.get('email').updateValueAndValidity();
       this.requestForm.get('email').setValidators([Validators.email]);
       this.store$.dispatch(new storyBuilderActions.SetInbound(true));
       this.store$.dispatch(new storyStepActions.Load(this.companyId, true, '', false));
       this.requestForm.controls.externalcampaign.setValue(-1);
       this.requestForm.controls.externalquestion.setValue(-1);
       this.isSingleInternalRequested = false;
       this.hideSendanCopylinkButton = false;
       this.emailSendIngPayload = [];
       this.isShowPromptContainer = false;
       
    }

    else if(this.requestForm.value.userStatus == 'Guestuser'  &&  this.isSingleInternalRequested){
      this.requestForm.controls.firstname.disable();
      this.requestForm.controls.lastname.disable();
      this.requestForm.controls.email.disable();
      this.requestForm.controls.note_email.disable();
      this.isSingleInternalRequested = true;
      this.store$.dispatch(new storyBuilderActions.SetInbound(true));
      this.store$.dispatch(new storyStepActions.Load(this.companyId, true, '', false));
      this.hideSendanCopylinkButton = true;
      this.emailSendIngPayload = [];
      this.isShowPromptContainer = false;
      
   }

    else{
      if(!this.isCopyCode){
        // this.requestForm.reset();
        this.store$.dispatch(new storyBuilderActions.SetInbound(false));
        this.store$.dispatch(new storyStepActions.Load(this.companyId, false, '', false));
        this.requestForm.controls.internalmessage.reset();;
        this.members = [];
        this.selectedData = []
        this.isCopyCode = false;
        this.loadUserInputData.pagination.page = 1;
        this.loadUserInputData.pagination.sort = 'desc'
        this.loadMembers([]);
        this.requestForm.controls.userStatus.setValue('user');
        this.requestForm.controls.campaign.setValue(-1);
        this.requestForm.controls.question.setValue(-1);
        this.hideSendanCopylinkButton = false;
        this.emailSendIngPayload = [];
        this.isShowPromptContainer = false;
      }
      else{
        this.requestForm.controls.internalmessage.reset();;
        this.requestForm.controls.userStatus.setValue('user');
        this.store$.dispatch(new storyBuilderActions.SetInbound(false));
        this.store$.dispatch(new storyStepActions.Load(this.companyId, false, '', false));
        this.hideSendanCopylinkButton = true;

      }



    }
    this.showemailSection = false;
    this.requestForm.controls.emailTemplate.setValue(this.allmails.find(email => email.title === 'TO A USER - when some requests a story from them').body);
    this.requestForm.controls.emailSubject.setValue(this.allmails.find(email => email.title === 'TO A USER - when some requests a story from them').subject);
  }


  showSearchBar(): void {
    if(!this.isBrowser) return;
    this.searchBarVisible = true;
    if(this.isBrowser){
      setTimeout(() => {
        document.getElementById("searchUnsplash").focus();
      }, 100);
    }

  }

  private unSubscribe() {
    if(!this.isBrowser) return;
    this.formChangeSubscription.unsubscribe();
    this.getNextUrlSubscription.unsubscribe();
    this.selectPlayerLoadingSubscription.unsubscribe();
    this.selectPlayerLoadedSubscription.unsubscribe();
    this.getMembersSubscription.unsubscribe();
    this.selectCurrentCompanySubscription.unsubscribe();
    this.selectCurrentProfileSubscription.unsubscribe();
    this.validateUserSuccessSubscription.unsubscribe();
    this.selcetFormSubscription.unsubscribe();
    this.loadPermissionSuccessSubscription.unsubscribe();
  }

  private loadMembers(selectedData: any[]) {
    if(!this.isBrowser) return;
    this.loadUserInputData.inbound = this.viewmodel.inbound;
    this.loadUserInputData.companyId = this.viewmodel.companyId;
    this.loadUserInputData.pagination.sort = 'desc'
    selectedData = selectedData || [];
    this.loadUserInputData.selectedValues = selectedData.filter(id => this.utility.Lodash.isNumber(id) && id > 0);
    let selectedEmails: string[] = [];
    const idsAsString = selectedData.filter(id => this.utility.Lodash.isString(id));
    idsAsString.forEach((sData: string) => {
      const emailParserRes = this.utility.StringHelper.emailParser(sData);
      selectedEmails.push(emailParserRes.email);
    });
    this.loadUserInputData.selectedEmails = selectedEmails;
    this.store$.dispatch(new userActions.Load(this.loadUserInputData));
  }

  private updateSelectedValues() {
    if(!this.isBrowser) return;
    const searchValue = this.form.controls.keyword.value;
    if (searchValue) {
      this.members = [...this.newMembers, ...this.members].filter(member => member.display_name.toLowerCase().includes(searchValue.toLowerCase()) || member.email.toLowerCase().includes(searchValue.toLowerCase()));
    } else {
      this.members = [...this.newMembers, ...this.members];
    }
    this.members.forEach((member: UserViewModel) => {
      member.checked = this.selectedData && (this.selectedData.indexOf(member.id) > -1 || this.selectedData.findIndex(f => isString(f) && f.indexOf(member.email) > -1) > -1);
    });
    this.selectedPeopleIds = (this.selectedData || []).filter((id) => this.utility.Lodash.isNumber(id) && id > 0);
    if(this.members.length){
      const selectedMembers = this.members.filter(member => member.checked);
      if(selectedMembers.length){
        this.diableonsearching = false;
      }
    }
    this.playersFormArray.controls[0].get('firstName').patchValue(searchValue);
    
  }

  private updateSelectedNoOneSpecific() {
    if(!this.isBrowser) return;
    this.isNoOneSpecific = false;
    if (this.selectedData && this.selectedData.indexOf(-1) > -1) {
      this.isNoOneSpecific = this.selectedData && this.selectedData.indexOf(-1) > -1;
    }
  }

  private resetAddPlayerForm() {
    if(!this.isBrowser) return;
    this.addPlayerForm.reset();
    this.addPlayerForm.setControl('players', this.formBuilder.array([this.createAddPlayerItemForm()]));
    this.isFormSubmited = false;
  }

  private resetSearchForm() {
    if(!this.isBrowser) return;
    this.form.reset({}, { emitEvent: false });
    this.loadUserInputData.search = '';
    this.loadMembers(this.selectedData);
  }

  private addPlayerSuccess() {
    if(!this.isBrowser) return;
    this.updateSelectedValues();
    this.resetAddPlayerForm();
    this.resetSearchForm();
    this.viewmodel.isPlayerCreating = false;
    this.updateData();
  }

  private emailValidator(control: UntypedFormControl) {
    if(!this.isBrowser) return;
    let value = control.value;
    if (!this.viewmodel.inbound && (!value || value.length === 0)) {
      return 'String empty';
    }
    return null;
  }

  private validateUsers() {
    if(!this.isBrowser) return;
    const emails = this.playersFormArray.value.map(player => player.email);
    this.store$.dispatch(new userActions.ValidateUser(emails));
  }

  private validateUsersSuccess(vuRes: ValidateUserOutApiModel[]) {
    if(!this.isBrowser) return;
    this.playersFormArray.controls.forEach((fgItem: UntypedFormGroup) => {
      const checkAllowAddToStory = vuRes.find(f => f.email === fgItem.controls.email.value && f.story_invite_enabled === true);
      if (!checkAllowAddToStory) {
        this.isHideErrorEmailInput = false;
        fgItem.controls.email.setErrors(
          {
            isCustom: true,
            message: 'Unavailable to add. Please try another email!'
          }
        );
      }
    });

    this.addPlayer();
  }

  private addPlayer() {
    if(!this.isBrowser) return;
    if (!this.addPlayerForm.valid) {
      this.viewmodel.isPlayerCreating = false;
      return;
    }

    this.isPlayerAdding = true;
    this.playersFormArray.controls.forEach((fgItem: UntypedFormGroup) => {
      let createUserData = new UserViewModel(null);
      createUserData.firstname = fgItem.controls.firstName.value;
      createUserData.lastname = '';
      createUserData.email = fgItem.controls.email.value || '';
      createUserData.displayName = `${createUserData.firstname}`;
      createUserData.id = `${createUserData.firstname} <${createUserData.email}>`;
      createUserData.checked = true;
      this.newMembers.unshift(createUserData);
      this.selectedData = this.selectedData || [];
      const newUserValue = `${createUserData.firstname} <${createUserData.email}>`;
      this.selectedData.push(newUserValue);
    });
    this.addPlayerSuccess();
  }

  public onYReachEnd() {
    if(!this.isBrowser) return;
    if (this.loadMore && this.viewmodel.scrollbarVisible && !this.isCopyCode && this.router.url != '/directory') {
      this.loadUserInputData.pagination.page += 1;
      //this.viewmodel.loadingDataOnScroll = true;
      this.loadMembers([]);
    }
  }

  public onPositionChanged() {
    if(!this.isBrowser) return;
    this.viewmodel.scrollbarVisible = true;
    if (this.loadMore && this.viewmodel.scrollbarVisible && !this.isCopyCode && this.router.url == '/directory') {
      this.loadUserInputData.pagination.page += 1;
      this.viewmodel.loadingDataOnScroll = true;
      this.loadMembers([]);
    }
  }

  public selectItem(player: UserViewModel) {
    if(!this.isBrowser) return;
    this.selectedData = this.selectedData && this.selectedData.filter((id: number) => (this.utility.Lodash.isNumber(id) && id > 0) || this.utility.Lodash.isString(id)) || [];
    this.isNoOneSpecific = false;
    this.diableonsearching = false;
    this.form.controls.keyword.reset()

    if (player.checked === true) {
      this.selectedData.push(player.id);
    } else {
      const index = this.selectedData.findIndex(f => f === player.id);
      this.selectedData.splice(index, 1);
    }

    this.selectedPeopleIds = [...this.selectedData];
    this.updateData();
  }

  public checkDisabled(member: any) {
    return this.requestedMembers.some(x => x.id === member.id);
  }

  public memberTrackByFnc(item) {
    return item.id;
  }

  public addPlayerFormSubmit() {
    if(!this.isBrowser) return;
    const emails = this.playersFormArray.value.map(player => player.email);
    // emails.forEach(email => {
    //   const splitEmail = email.split('@');
    //   const emailDomain = splitEmail[1];
    //   if (!this.company.domains.find(domain => domain.domain === emailDomain)) {
    //     this.playersFormArray.controls.forEach((fgItem: FormGroup) => {
    //       if (fgItem.controls.email.value === email) {
    //         this.isHideErrorEmailInput = false;
    //         fgItem.controls.email.setErrors(
    //           {
    //             isCustom: true,
    //             message: 'Invalid domain!'
    //           }
    //         );
    //       }
    //     });
    //   }
    // });
    if (this.addPlayerForm.invalid) return;
    this.isFormSubmited = true;
    this.viewmodel.isPlayerCreating = true;

    this.validateUsers();
  }

  public updateData() {
    if(!this.isBrowser) return;
    this.loadMembers(this.selectedData);
  }

  public handleComKeyEnter() {
  }

  externalchangeData(data){
    if(!this.isBrowser) return;
    if(typeof data === 'string' ){
      if(data != '-1'){
        this.requestForm.controls.about.setValue(this.questionList.find(item => item.id == +data).question_text)
        this.externalquestionid = +data
        this.isShowPromptContainer = true;
        this.requestForm.controls.content.setValue(this.requestForm.value.about);
        this.readOnlyforTextfiled = false;
        this.requestForm.controls.externalcampaign.reset();
        this.requestForm.controls.externalcampaign.setValue(-1);

      }
  
 
    }
  }

  changeData(data){
    if(!this.isBrowser) return;
    if(typeof data === 'string' ){
      if(data != '-1'){
        this.requestForm.controls.about.setValue(this.questionList.find(item => item.id == +data).question_text)
        this.internalQuestionId = +data;
        this.isShowPromptContainer = true;
        this.requestForm.controls.content.setValue(this.requestForm.value.about);
        this.readOnlyforTextfiled = false;
        this.requestForm.controls.campaign.reset();
        this.requestForm.controls.campaign.setValue(-1);

      }
  
 
    }
  }


  public exceptHandleComKeyEnter(event) {
    if(!this.isBrowser) return;
    event.stopPropagation();
  }
  public exceptHandleComKeyEnterKey(event) {
    if(!this.isBrowser) return;
    event.stopPropagation();
  }

  get playersFormArray() {
    if(!this.isBrowser) return;
    return this.addPlayerForm.get('players') as UntypedFormArray;
  }

  public addPlayerFormItem() {
    if(!this.isBrowser) return;
    this.playersFormArray.push(this.createAddPlayerItemForm());
  }

  public removeAddPlayerFormItem($event, index) {
    if(!this.isBrowser) return;
    $event.stopPropagation();
    this.playersFormArray.removeAt(index);
  }

    public close() {
      if(!this.isBrowser) return;
      this.resetAddPlayerForm();
      this.resetSearchForm(); 
  }

  cancel() {
    if(!this.isBrowser) return;
    this.onClose.emit(false);
  }
  

  sendRequest() {
    if(!this.isBrowser) return;
    this.isLoading = true;
    const selectedMembers = this.members.filter(member => member.checked);
    if (selectedMembers.length) {
      const payload: RequestInputApiModel = {
        author_emails: selectedMembers.map((member: UserViewModel) => { return member.email }),
        story_prompt: this.requestForm.value.about,
        campaign_id: this.requestForm.value.campaign,
        story_title: this.requestForm.value.about,
        story_requested: 1,
        question_id_campaign: this.requestForm.value.question_id_campaign
      }
      this.requestService.request(payload).subscribe({
        next: (data: any) => {
        this.isLoading = false;
        this.isCopyCode = true;
        this.requestedUsers = data
        this.checkForSelectedUsers(data);
        this.requestForm.patchValue({
          requestedUser: data[0].url,
          bodyCode: data[0].url
        }, {emitEvent: false})
        },
        error: (err) => this.onRequestLinkError(err),
      })
    }
  }

  private checkForSelectedUsers(data: any) {
    if(!this.isBrowser) return;
    var tempDatastorage = []
    this.hideSendanCopylinkButton = true;
    this.internalUrl = true;
    this.emailSendIngPayload = [];
    if(data.length == 1){
      let emailPaylooad 
       this.InternalStorySingleUrl  = data[0].url;
       if(this.requestForm.value.campaign != -1){
        emailPaylooad  =  {
          author_email: data[0].email,
          story_id: data[0].story?.id,
          interview_style:this.interviewStyle,
          campaign_id:this.requestForm.value.campaign
         }
        }
        else{
          emailPaylooad  =  {
            author_email: data[0].email,
            story_id: data[0].story?.id,
            interview_style:this.interviewStyle,
        }
       }
 
       this.emailSendIngPayload.push(emailPaylooad)
       this.members.forEach((item, i) => {
        data.forEach((items, j) => {
          if (items.email == item.email) {
            item["url"] = items.url
             item["story_id"] = data[0].story?.id,
            tempDatastorage.push(item)
          }
        })
      })
       this.members = [];
       this.members = tempDatastorage
    }
    else if (data.length > 1 ){
      let multipleEmailPayload;
        data.forEach((author)=>{
          
          if(this.requestForm.value.campaign != -1){
            multipleEmailPayload = {
              author_email: author.email,
              story_id: author.story?.id,
              campaign_id: this.requestForm.value.campaign,
              interview_style:this.interviewStyle
             } 
          }
          else{
            multipleEmailPayload = {
              author_email: author.email,
              story_id: author.story?.id,
              interview_style:this.interviewStyle,
             } 
          }
 
           this.emailSendIngPayload.push(multipleEmailPayload)
        })
        this.hideSendanCopylinkButton = true;
        this.members.forEach((item, i) => {
          data.forEach((items, j) => {
            if (items.email == item.email) {
              item["url"] = items.url
              item["story_id"] = items?.story?.id
              tempDatastorage.push(item)
            }
          })
        })
        this.members = [];
        this.members = tempDatastorage
    }
  }

  addquestion(){
    if(!this.isBrowser) return;
    const initData = {
      companyId: this.companyId,
      inbound: this.requestForm.value.userStatus == 'Guestuser' ? true : false,
      fromTag: false,
      main_board:true
    }
    this.modalService.showModal(CreateTagsModalComponent, initData).then((isConfirm: boolean) => {
      if (isConfirm) {
        this.question_clicked = true;
        this.store$.dispatch(new storyStepActions.LoadQuestions(this.companyId));
      }
      else{
        this.question_clicked = false;
      }
    });
  }
  GenearateInternalMainlLink(){
    const selectedMembers = this.members.filter(member => member.checked);
    this.isLoading = true;
    let payload = {
      author_emails: selectedMembers.map((member: UserViewModel) => { return member.email }),
      campaign_id: this.requestForm.value.campaign,
      story_requested: 1,
    }
    this.showEmailEditor = false;
    payload['is_video'] = this.is_video;
    payload['asset_id'] = this.asset_id;
    payload['emailTemplate'] = this.requestForm.controls.emailTemplate.value;
    payload['emailSubject'] = this.requestForm.controls.emailSubject.value;
    payload['story_steps'] = this.dynamicObject;
    console.log("this", this.dynamicObject);
     if(this.requestForm.value.campaign != -1){
      payload['interview_style'] = this.interviewStyle
     }
    if(this.requestForm.value.internalmessage){
      payload['message']=this.requestForm.value.internalmessage
    }

    if(this.requestForm.value.languageSelected){
      payload['lang_code'] = this.requestForm.value.languageSelected;
    }
    if(this.requestForm.value.about){
      payload['storyPrompt'] = this.requestForm.value.about;
      payload['story_title'] = this.requestForm.value.about;
      payload['story_question_id'] = this.internalQuestionId;
    }
    const requestorId = this.requestForm.value.userselcted;
    if (requestorId && +requestorId !== +this.loggedInUserId) {
      payload['requested_by_id'] = requestorId;
    }

    if(this.internalUrl){
       payload['old_url'] = this.members;
       payload['is_internal'] = true;
    }
    this.requestService.request(payload).subscribe({
      next: (data: any) => {
      this.isLoading = false;
      this.isCopyCode = true;
      this.requestedUsers = data
      this.hideSendanCopylinkButton = true;
      this.checkForSelectedUsers(data);
      // this.requestForm.controls.emailTemplate.setValue(this.allmails.find(email => email.title === 'TO A USER - when some requests a story from them').body);
      // this.requestForm.controls.emailSubject.setValue(this.allmails.find(email => email.title === 'TO A USER - when some requests a story from them').subject);
      this.requestForm.patchValue({
        requestedUser: data[0].url,
        bodyCode: data[0].url
      }, {emitEvent: false})
      },
      error: (err) => this.onRequestLinkError(err),
    })
  }

  openTag(data){
    if(!this.isBrowser) return;
    this.isShowModal= true;
    const Index = this.stepActive.findIndex((step:any) => step.id == data);
    const step = this.stepActive[Index];
    if (step && step.id == 16) {
      this.isShowmedia = true;
      this.isshowTag = false;
    } else {
      this.isshowTag = true;
      this.isShowmedia = false;
    }
    this.panelCloseColor = (step && step.color) ? step.color : '#106e47';
    this.store$.dispatch(new storyBuilderActions.GotoStep(step.id));
    this.store$.dispatch(new storyBuilderActions.SetStepActive(step));
  }

  GenearateExternalMainlLink(){
    if(!this.isBrowser) return;
    this.isLoading = true;
    let payload = {
      campaign_id: this.requestForm.value.externalcampaign,
      story_requested: 1,
      author_emails:[]
    }
    this.showEmailEditor = false;
    payload['is_video'] = this.is_video;
    payload['asset_id'] = this.asset_id;
    payload['emailTemplate'] = this.requestForm.controls.emailTemplate.value;
    payload['emailSubject'] = this.requestForm.controls.emailSubject.value;
    payload['story_steps'] = this.dynamicObject;
    if(this.requestForm.value.externalcampaign != -1){
      payload['interview_style'] = this.interviewStyle
     }

     if(this.requestForm.value.languageSelected){
      payload['lang_code'] = this.requestForm.value.languageSelected;
    }
  
    if(this.requestForm.controls.firstname.value){
      payload['firstname']=this.requestForm.controls.firstname.value;
    }
    if(this.requestForm.controls.lastname.value){
      payload['lastname']=this.requestForm.controls.lastname.value;
    }
    if(this.requestForm.value.message){
      payload['message']=this.requestForm.value.message;
    }
    if(this.requestForm.controls.note_email.value){
      payload['note_email']=this.requestForm.controls.note_email.value;
    }
    if(this.requestForm.value.about){
      payload['storyPrompt'] = this.requestForm.value.about;
      payload['story_title'] = this.requestForm.value.about;
      payload['story_question_id'] = this.externalquestionid;
    }
    const externalRequestorId = this.requestForm.value.externalUserSelcted;
    if (externalRequestorId && +externalRequestorId !== +this.loggedInUserId) {
      payload['requested_by_id'] = externalRequestorId;
    }

    if(this.externalUrlforCopy){
      payload['url'] = this.externalUrlforCopy;
    }
    this.requestService.request(payload).subscribe({
      next: (data: any) => {
      this.isLoading = false;
      this.requestedUsers = data
      this.checkForExternalSelectedUsers(data);
      },
      error: (err) => this.onRequestLinkError(err),
    })
  }

  private onRequestLinkError(err: any): void {
    this.isLoading = false;
    const body = err?.error;
    const message = (body && (body.error || body.message)) ||
      'Could not create the request link. Wait a moment and try again.';
    this.toastService.error(message);
  }


  private checkForExternalSelectedUsers(data){
    if(!this.isBrowser) return;
    var tempDatastorage = []
    this.emailSendIngPayload = [];
    // this.requestForm.controls.firstname.disable();
    // this.requestForm.controls.lastname.disable();
    // // this.requestForm.controls.email.disable();
    // this.requestForm.controls.note_email.disable();
    if(data.length == 1){
      this.isSingleInternalRequested = true;
      
      this.hideSendanCopylinkButton = true;
       this.externalUrlforCopy  = data[0].url;
        if(data && data[0].story && data[0].story?.storyid){
          let emailPaylooad = {}
          let emails =  {
            author_email: data[0].email,
            story_id: data[0].story?.id
           }
           this.emailSendIngPayload.push(emails)

 
        }
        else{
          let emailPayload  =  {
            author_email: [],
            // firstname:this.requestForm.value.firstname,
            // lastname:this.requestForm.value.lastname,
            // campaign_id: this.requestForm.value.campaign,
            // story_requested: 1,
           }
          //  if(this.requestForm.value.about){
          //   emailPayload['story_title'] = this.requestForm.value.about
          //  }
          this.emailSendIngPayload.push(emailPayload)
        }


       
    }


  }

  sendIntenalMainEmail(){
    if(!this.isBrowser) return;
    let emails= {
      author_emails: this.emailSendIngPayload,
      emailTemplate: this.requestForm.controls.emailTemplate.value,
      emailSubject:  this.requestForm.controls.emailSubject.value,
    }
    if(!this.is_not_other_email){
      emails['request_sender_name'] = this.requestForm.value.emailSendername;
    }
    const emailRequestorId = this.requestForm.value.userselcted;
    if (emailRequestorId && +emailRequestorId !== +this.loggedInUserId) {
      emails['requested_by_id'] = emailRequestorId;
    }
    if(this.requestForm.value.languageSelected){
      emails['lang_code'] = this.requestForm.value.languageSelected;
    }
    this.interviewStyle = false;
    this.store$.dispatch(new storyAction.SendEamilInternalExternal(emails));
    this.toastService.success('Sent')
    // // this.requestForm.reset();
    // this.resetState();
    // this.requestForm.controls.internalmessage.reset();;
    // this.members = [];
    // this.selectedData = [];
    // this.emailSendIngPayload = [];
    // this.isCopyCode = false;
    // this.sendInternalmail = false;
    // this.internalUrl = false;
    // this.selectedPeopleIds = [];
    // this.hideSendanCopylinkButton = false;
    // this.requestForm.controls.userStatus.setValue('user');
    // this.requestForm.controls.campaign.setValue(-1);
    // this.requestForm.controls.question.setValue(-1);
    // this.loadUserInputData.pagination.page = 1;
    // this.loadUserInputData.pagination.sort = 'desc'
    // this.toastService.success('Sent')
    // this.loadMembers([]);
  }


  sendExternalMainEmail(){
    if(!this.isBrowser) return;
    // let emails= {
    //   author_emails: this.emailSendIngPayload
    this.isShowModal = false;
    this.resetModalWidth();
    if(!this.showemailSection){
      this.showemailSection = true;

    }
    else{
      let emails= {
        author_emails: this.requestForm.controls.users.value,
        emailTemplate: this.requestForm.controls.emailTemplate.value,
        emailSubject:  this.requestForm.controls.emailSubject.value,
        link:this.externalUrlforCopy
      }
      if(!this.is_not_other_email){
        emails['request_sender_name'] = this.requestForm.value.emailSendername;
      }

      if(this.requestForm.value.languageSelected){
        emails['lang_code'] = this.requestForm.value.languageSelected;
      }
      const externalEmailRequestorId = this.requestForm.value.externalUserSelcted;
      if (externalEmailRequestorId && +externalEmailRequestorId !== +this.loggedInUserId) {
        emails['requested_by_id'] = externalEmailRequestorId;
      }
      this.toastService.success("Sent")
      this.store$.dispatch(new storyAction.SendEamilInternalExternal(emails));
    //   this.requestForm.controls.firstname.reset();
    //  this.requestForm.controls.lastname.reset();
    //  this.requestForm.controls.email.reset();
    //  this.requestForm.controls.users.reset();
    //  this.resetState();
    //  this.externalUrlforCopy = '';
    //  this.emailSendIngPayload = [];
    //  this.isSingleInternalRequested = false;
    //  this.hideSendanCopylinkButton = false;
    //  this.showemailSection = false;
    }

  }

  

  Changecampaigns(data){
    if(!this.isBrowser) return;
    if(typeof data === 'string' && data != '-1'){
       //console.log(data);
       this.camapignqueston = [];
       let campaign = this.campaigns.find(campaign => campaign.id == +data);
       if (!campaign?.storyPrompt?.length) {
         return;
       }
       this.interviewStyle = campaign.interview_style
       let campaignQuestion = campaign.storyPrompt
       .filter(item => item.is_campaign || item.is_stories)
       .map(item => item.story_prompt);
       this.camapignqueston = [...campaignQuestion];
       this.isShowPromptContainer = true;
       this.requestForm.controls.content.setValue(campaignQuestion);
       this.readOnlyforTextfiled = true;
       this.requestForm.controls.question.reset();
       this.requestForm.controls.question.setValue(-1);
       this.requestForm.controls.about.setValue('');
    }
  }

  extermalChangecampaigns(data){
    if(!this.isBrowser) return;
    if(typeof data === 'string' && data != '-1'){
       //console.log(data);
       this.externalCampaignQuestion = [];
       let campaign = this.campaigns.find(campaign => campaign.id == +data);
       if (!campaign?.storyPrompt?.length) {
         return;
       }
       this.interviewStyle = campaign.interview_style
       let campaignQuestion = campaign.storyPrompt
       .filter(item => item.is_campaign || item.is_stories)
       .map(item => item.story_prompt);
       this.externalCampaignQuestion = [...campaignQuestion];
       this.isShowPromptContainer = true;
       this.requestForm.controls.content.setValue(campaignQuestion);
       this.readOnlyforTextfiled = true;
       this.requestForm.controls.externalquestion.reset();
       this.requestForm.controls.externalquestion.setValue(-1);
       this.requestForm.controls.about.setValue('');
    }
  }

  copyMessage(player, data: any) {
    if(!this.isBrowser) return;
    if(this.isBrowser){
      const selBox = document.createElement('textarea');
      selBox.style.position = 'fixed';
      selBox.style.left = '0';
      selBox.style.top = '0';
      selBox.style.opacity = '0';
      selBox.value = player.url;
      document.body.appendChild(selBox);
      selBox.focus();
      selBox.select();
      document.execCommand('copy');
      document.body.removeChild(selBox);
      $(data).attr('title', 'Copied');
  
      player.linkCopied = true;
      setTimeout(() => {
        $(data).attr('title', 'Click to copy');
        player.linkCopied = false;
      }, 1000)
    }
   
  }

  copyExternalUrl() {
    if(!this.isBrowser) return;
    if(this.isBrowser){
      const selBox = document.createElement('textarea');
      selBox.style.position = 'fixed';
      selBox.style.left = '0';
      selBox.style.top = '0';
      selBox.style.opacity = '0';
      selBox.value = this.externalUrlforCopy;
      document.body.appendChild(selBox);
      selBox.focus();
      selBox.select();
      document.execCommand('copy');
      document.body.removeChild(selBox);
      // this.buttonText = 'Copied'
      this.toastService.success("Copied");
      setTimeout(() => {
        this.buttonText = 'Copy'
      }, 1000)
    }

  }
  shareadthis(){
    if(!this.isBrowser) return;
    if(this.isBrowser){
      this.isDispalyadthis = true;
      setTimeout(()=>{
        if (typeof (<any>window).shareholic !== 'undefined') { (<any>window).shareholic.layers.refresh(); }
        this.shareholic.nativeElement.setAttribute("data-link", this.externalUrlforCopy);
      },1000)
    }

  }
  closeshare(){
    if(!this.isBrowser) return;
    this.isDispalyadthis = false;
  }

  closetagbox(data){
    if(!this.isBrowser) return;
  }

  addMedia(){
    if(!this.isBrowser) return;
  if(this.isBrowser){
    // this.loadGallery();
    this.isShowModal= true;
    this.isShowmedia = true;
    this.isshowTag = false;
    const mediaStep = this.mediaStep;
    // White close icon while Add Media is active; menu icons override via openTag.
    this.panelCloseColor = '#ffffff';
    this.store$.dispatch(new storyBuilderActions.GotoStep(2));
    // Steps still loading: syncOpenPanelStep() sends it when they arrive.
    if (mediaStep) {
      this.store$.dispatch(new storyBuilderActions.SetStepActive(mediaStep));
    }
    this.widenRequestModal();
  }

  }



  /** Give the open Tags / Media panel its step once the steps have loaded. */
  private syncOpenPanelStep(): void {
    if (!this.isShowModal || !this.stepActive) {
      return;
    }
    const step = this.isShowmedia
      ? this.mediaStep
      : (this.isshowTag ? this.stepActive[0] : null);
    if (step) {
      this.store$.dispatch(new storyBuilderActions.SetStepActive(step));
    }
  }

  addTag(){
    if(!this.isBrowser) return;
if(this.isBrowser){
    this.isShowModal= true;
    this.isshowTag = true;
    this.isShowmedia = false;
    const tagStep = this.stepActive ? this.stepActive[0] : null;
    this.panelCloseColor = (tagStep && tagStep.color) ? tagStep.color : '#106e47';

    this.store$.dispatch(new storyBuilderActions.GotoStep(2));
    if (tagStep) {
      this.store$.dispatch(new storyBuilderActions.SetStepActive(tagStep));
    }

    this.widenRequestModal();
}
  }

    commonUploadFuctionality(){
      if(!this.isBrowser) return;
      // this.downloaded = true
      if(this.isBrowser){
        var uploadId:any;
        this.store$.dispatch(new mediaDownloadAction.CheckDownloaf(true))
        const muxUploader:any = document.getElementById("my-uploader-gs-res");
        const self = this;
        // const fileName = 'example.mp4'; // Replace with your desired filename
        // const file = new File([this.videoCurrentUrl], fileName, { type: 'video/mp4' });
        this.uploaderInstance = muxUploader;
        muxUploader.endpoint = async () => {
          const payload = {
            origin:window.location.origin
          }
    
          // let cId = localStorage.getItem("cId")
          // let companyId = +cId;
         
           const uploadUrl = await this.storyHttpService.pollApiUntilReady(this.companyId,payload).toPromise();
           uploadId = uploadUrl.id
          return uploadUrl.url
    
        }
        //console.log(">>",this.normalFile.target.files[0])
      
        muxUploader.dispatchEvent(
          new CustomEvent("file-ready", {
            composed: true,
            bubbles: true,
            detail: this.videoCurrentUrl.originalFile,
          })
        )
        muxUploader.addEventListener("progress", function (e: any) {
          //console.log(`My upload is ${e.detail}% complete!`);
           let progessCss= Math.trunc(e.detail);
           self.uploaderViewModel.isUploading = true;
           if(progessCss != 100){
             self.uploaderViewModel.progressCss = progessCss+'%';
             self.store$.dispatch(new mediaActions.checkAssetReadyOrNot(true,'Uploading',progessCss+'%'))
           }
           if(progessCss == 100){
            self.store$.dispatch(new mediaActions.checkAssetReadyOrNot(true,'Uploading in progress','99.9506%'))
            // self.uploaderViewModel.isUploading = false;
            self.uploaderViewModel.progressCss = 90+'%';
            // self.makeMuxApiRequest(uploadId)
           }
     
        });
        muxUploader.addEventListener("success", function (e: any) {
          self.uploaderViewModel.progressCss = 87+'%'
          self.makeMuxApiRequest(uploadId)
    });
    
    const onPageLeave = () => {
      if (muxUploader && muxUploader.abort) {
        muxUploader.abort(); // Use Mux's abort method
      }
    ; // Cancel any pending fetch requests
      //console.log('Upload canceled due to page leave');
    };
      }

    }


  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    if(this.isBrowser) {
      this.isSmallScreen = window.screen.width <= 700;
    }
  }

  // private initUploader() {
  //   if(!this.isBrowser) return;
    
  //   const config = {
  //     // button: this.browseFileButton.first.nativeElement,
  //     companyId: this.companyId,
  //     isAnonymous: true,
  //     autoUpload: true,
  //     multiple: true,
  //     validate: {
  //       allowedExtensions: ['gif', 'jpeg', 'jpg', 'png', 'mp4', 'mpg', 'mov', '3gp', 'avi', 'flv', 'm4v', 'mkv', 'mpeg', 'mts', 'ogv', 'vob', 'webm']
  //     },
  //     messages: {
  //       imageDimensionError: 'Use a larger image - 640 x 480px minimum.',
  //       typeError: 'Acceptable file formats are gif, jpg, jpeg, png, mp4, mpg and mov.'
  //     }
  //   };

  //   const callbacks = new Callback();
  //   callbacks.onSubmit = this.onUploaderSubmit.bind(this);
  //   callbacks.onComplete = this.onUploaderComplete.bind(this);
  //   callbacks.onError = this.onUploaderError.bind(this);
  //   callbacks.onProgress = this.onProgress.bind(this);
  //   callbacks.onAllComplete = this.onUploaderAllComplete.bind(this);

  //   this.uploader = this.uploaderService.s3Uploader(config, callbacks);
  // }

  private onProgress(id: any, name: any, loaded: any, total: any) {
    if(!this.isBrowser) return;
    this.uploaderViewModel.progress = (loaded / total) * 100;
    this.uploaderViewModel.progressCss = this.uploaderViewModel.progress + '%';
    this.detector.detectChanges();
  }

  private onUploaderSubmit(id) {
    if(!this.isBrowser) return;
    this.uploaderViewModel.isUploading = true;
    this.uploaderViewModel.isError = false;
    this.detector.detectChanges();
  }

  private onUploaderComplete(id: any, name: any, responseJSON: any, maybeXhr: any) {
    if(!this.isBrowser) return;
    this.uploaderViewModel.isUploading = false;
    this.uploaderViewModel.isError = false;
    this.detector.detectChanges();
  }

  private onUploaderAllComplete() {
    if(!this.isBrowser) return;
    this.uploaderViewModel.isUploading = false;
    this.detector.detectChanges();
  }

  private onUploaderError(id: any, name: any, reason: any, maybeXhrOrXdr: any) {
    if(!this.isBrowser) return;
    this.uploaderViewModel.isUploading = false;
    this.uploaderViewModel.isError = true;
    this.uploaderViewModel.errorMsg = reason;
    this.detector.detectChanges();
  }

  // private tagCustomValidate(control: UntypedFormControl) {
  //   if(!this.isBrowser) return null;
  //   const value = control.value;
  //   if (!value) return null;

  //   const isExisted = this.tags.some(tag => tag.name.toLowerCase() === value.toLowerCase());
  //   if (isExisted) {
  //     return { existed: true };
  //   }

  //   return null;
  // }

  public tagTrackByFn(index, tagItem) {
    return tagItem.id;
  }


  startRecording() {
    if(this.isBrowser){
    // this.store$.dispatch(new mediaRecordAction.CheckRecord(true))
    // recordData.open();
    // this.isShowRecorder = true;
    // this.isCamera = false;
    let data = {
      storyParam :'',
      questionModels:[],
      showPreviousNextButton:false,
      companyID :this.companyId,
      currentCompany: '',
      interViewStyle: true,
      isPreview: true,
      videoduration: 3 * 60,
      inbound_builder: true,
      isCamera:false,
      isCameraOnly:false,
      allowVideoUpload: true,
      themeButtonColor: this.secondary_button_color
    }

    this.isGreetingRecordingOpen = true;
    this.modalService.showModal(RequestVideoRecorderMediaComponent ,data, {class:'modal-lg-video'}).then((data)=>{
      this.isGreetingRecordingOpen = false;

      if(data){
        this.showelipse = true;
        this.onRecordFinish(data.blobcontent);
        const videoUrl = URL.createObjectURL(data.blobcontent);
        this.dataUrl = videoUrl;
        if(data.campaignDetail){
          // this.campaIgnDetail(data.campaignDetail)
        }
      }
    })

    // let initializeOptions = {token: }
    // const onVideoSdkInitialize = (data, error) => { if(data)
    //   const recorder = RecorderWidget.create(data.key, config);
  }

  }
  public triggerGreetingVideoUpload(): void {
    if (!this.isBrowser) return;
    this.greetingVideoInput?.nativeElement?.click();
  }

  public uploadGreetingVideo(event: Event): void {
    if (!this.isBrowser) return;
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    if (!file) return;

    if (!file.type.startsWith('video/')) {
      this.toastService.error('Please select a valid video file.');
      input.value = '';
      return;
    }

    this.showelipse = true;
    this.dataUrl = URL.createObjectURL(file);
    this.uploadGreetingFile(file);
    input.value = '';
  }

  public onRecordFinish(recorderData: any) {
    if (this.isBrowser) {
      this.uploadGreetingFile(recorderData);
    }
  }

  private resetGreetingUploadState(): void {
    this.showelipse = false;
    this.is_video = false;
    this.greetingReady = false;
    this.dataUrl = '';
    this.asset_id = '';
    this.pendingGreetingUploadId = '';
    this.uploaderViewModel.isUploading = false;
    this.uploaderViewModel.progress = 0;
    this.uploaderViewModel.progressCss = '0%';
  }

  private bindGreetingMuxUploader(muxUploader: any): void {
    if (this.greetingMuxUploaderBound || !muxUploader) {
      return;
    }

    this.greetingMuxUploaderBound = true;
    const self = this;

    muxUploader.addEventListener('progress', (e: any) => {
      const percent = Math.trunc(e.detail);
      self.uploaderViewModel.isUploading = true;
      self.uploaderViewModel.progress = percent;
      self.uploaderViewModel.progressCss = `${percent}%`;

      if (percent === 100 && self.pendingGreetingUploadId) {
        self.uploaderViewModel.progress = 100;
        self.uploaderViewModel.progressCss = '100%';
        self.uploaderViewModel.isUploading = false;
        self.makeMuxApiRequest(self.pendingGreetingUploadId);
      }
    });

    muxUploader.addEventListener('success', () => {
      self.uploaderViewModel.progress = 100;
      self.uploaderViewModel.progressCss = '100%';
      self.uploaderViewModel.isUploading = false;
      if (self.pendingGreetingUploadId) {
        self.makeMuxApiRequest(self.pendingGreetingUploadId);
      }
    });

    muxUploader.addEventListener('uploaderror', () => {
      self.resetGreetingUploadState();
      self.toastService.error('Video upload failed. Please try again.');
    });
  }

  private uploadGreetingFile(file: File | Blob): void {
    if (!this.isBrowser) return;
    const muxUploader: any = document.getElementById('my-uploader-gs');
    if (!muxUploader) return;
    muxUploader.dynamicChunkSize = true;

    this.bindGreetingMuxUploader(muxUploader);
    this.pendingGreetingUploadId = '';
    this.showelipse = true;
    this.is_video = true;
    this.uploaderViewModel.isUploading = true;
    this.uploaderViewModel.progress = 0;
    this.uploaderViewModel.progressCss = '0%';

    const greetingFile = file instanceof File
      ? file
      : new File([file], 'greeting.mp4', { type: file.type || 'video/mp4' });

    muxUploader.endpoint = async () => {
      const payload = { origin: window.location.origin };
      const uploadUrl = await this.storyHttpService
        .pollApiUntilReady(this.companyId, payload)
        .toPromise();
      this.pendingGreetingUploadId = uploadUrl.id;
      return uploadUrl.url;
    };

    muxUploader.dispatchEvent(
      new CustomEvent('file-ready', {
        composed: true,
        bubbles: true,
        detail: greetingFile,
      })
    );
  }

  
  makeMuxApiRequest(id): void {
    if(!this.uploadedId.length){
      this.uploadedId.push(id);
      this.makeAPiRequest(id);
    }
    if(this.uploadedId.length){
      let index = this.uploadedId.findIndex(item => item == id);
      if(index>=0){
        return
      }
      else{
        this.uploadedId.push(id)
        this.makeAPiRequest(id);
      }
    }

  }

  makeAPiRequest(id, attempt = 0){
    const maxAttempts = 4;
    this.storyHttpService.CheckpollApiUntilReady(id,this.companyId)
    .subscribe(
      (response: any) => {
        this.asset_id = response;
        this.showelipse = false;
        this.greetingReady = true;
        this.pendingGreetingUploadId = '';
        this.toastService.success('Greeting video added. You can create the link.');

        if(this.externalUrlforCopy && !this.showemailSection){
          this.isSingleInternalRequested = false;
        }
        if(this.internalUrl && !this.sendInternalmail){
          this.hideSendanCopylinkButton = false;
        }
      },
      (error) => {
        console.error('Error:', error);
        if (attempt < maxAttempts) {
          setTimeout(() => this.makeAPiRequest(id, attempt + 1), 3000);
          return;
        }
        this.resetGreetingUploadState();
        this.toastService.error(
          'Video processing failed. Please upload your greeting again.'
        );
      }
    );
  }

  watchVideo(){
    this.isDispalyMenu = true;
    this.show_video = true;
    
    setTimeout(()=>{
      this.videoPlayer.nativeElement.src = this.dataUrl;
    },100)
  }

  acceptVideo() {
    this.videoAccepted = true;
    this.isDispalyMenu = false;
    this.show_video = false;
  }

  rerecordVideo() {
    this.isDispalyMenu = false;
    this.show_video = false;
    
    const originalDataUrl = this.dataUrl;
    const originalAssetId = this.asset_id;
    const originalVideoAccepted = this.videoAccepted;
    
    let data = {
      storyParam: '',
      questionModels: [],
      showPreviousNextButton: false,
      companyID: this.companyId,
      currentCompany: '',
      interViewStyle: true,
      isPreview: true,
      videoduration: 3 * 60,
      inbound_builder: true,
      isCamera: false,
      isCameraOnly: false,
      allowVideoUpload: true,
      themeButtonColor: this.secondary_button_color
    };

    this.isGreetingRecordingOpen = true;
    this.modalService.showModal(RequestVideoRecorderMediaComponent, data, {class: 'modal-lg-video'}).then((data) => {
      this.isGreetingRecordingOpen = false;
      if(data && data.blobcontent){
        this.showelipse = true;
        this.onRecordFinish(data.blobcontent);
        const videoUrl = URL.createObjectURL(data.blobcontent);
        this.dataUrl = videoUrl;
        this.videoAccepted = false;
        if(this.externalUrlforCopy){
          this.isSingleInternalRequested = false;
        }
        if(this.internalUrl){
          this.hideSendanCopylinkButton = false;
        }
      } else {
        const confirmationData = {
          title: 'Keep Original Video?',
          message: 'You closed the recording without creating a new video. Would you like to keep your original video or remove it?',
          yesButtonText: 'Keep Original',
          cancelButtonText: 'Remove Video'
        };
        
        this.modalService.showModal(ConfirmationModalComponent, confirmationData, {class: 'modal-sm'}).then((keepVideo) => {
          if(keepVideo) {
            this.dataUrl = originalDataUrl;
            this.asset_id = originalAssetId;
            this.videoAccepted = originalVideoAccepted;
            this.is_video = true;
          } else {
            this.dataUrl = '';
            this.is_video = false;
            this.asset_id = '';
            this.greetingReady = false;
            this.videoAccepted = false;
            if(this.externalUrlforCopy){
              this.isSingleInternalRequested = false;
            }
            if(this.internalUrl){
              this.hideSendanCopylinkButton = false;
            }
          }
        });
      }
    });
  }

  removeVideo(){
    this.isDispalyMenu = false;
    this.show_video = false;
    this.dataUrl = ''
    this.is_video = false;
    this.asset_id = ''
    this.greetingReady = false;
    this.videoAccepted = false;
    if(this.externalUrlforCopy){
      this.isSingleInternalRequested = false;
    }

    if(this.internalUrl){
      this.hideSendanCopylinkButton = false;
    }
  }






    // Reset modal width to original size
    public widenRequestModal(): void {
      if (!this.isBrowser) return;
      const modalWrapper = document.querySelector('.modal-lg-request') as HTMLElement;
      if (!modalWrapper) return;
      const width = Math.min(1218, Math.max(640, window.innerWidth - 32));
      modalWrapper.classList.add('expand');
      modalWrapper.style.maxWidth = `${width}px`;
      modalWrapper.style.width = `${width}px`;
    }

    public resetModalWidth(): void {
      if(!this.isBrowser) return;
      const modalWrapper = document.querySelector('.modal-lg-request') as HTMLElement;
      if (modalWrapper) {
        modalWrapper.classList.remove('expand');
        modalWrapper.style.width = '';
        modalWrapper.style.maxWidth = '';
        modalWrapper.style.transition = '';
      }
    }

    // User type selection method
    public setUserStatus(userType: 'user' | 'Guestuser'): void {
      if (!this.isBrowser) return;
      if (userType === 'user' && !this.showUserRequestTab()) {
        return;
      }
      if (userType === 'Guestuser' && !this.showGuestRequestTab()) {
        return;
      }

      const current = this.userTabSwapping
        ? this.pendingUserStatus
        : this.requestForm.value.userStatus;
      if (current === userType) {
        return;
      }

      this.pendingUserStatus = userType;
      this.applyUserStatus(userType);
      this.userTabSwapping = false;
    }

    private applyUserStatus(userType: 'user' | 'Guestuser'): void {
      // User and Guest use separate campaign/message controls; carry them over.
      const carry = this.captureUserSwitchCarryOver();
      this.requestForm.controls.userStatus.setValue(userType);

      if (userType === 'Guestuser') {
        const noteEmail = this.requestForm.controls.note_email;
        if (!noteEmail.value) {
          noteEmail.markAsPristine();
          noteEmail.markAsUntouched();
        }
      }

      this.Chnageuserstatus(null, carry.media, carry.tagSteps);
      this.restoreUserSwitchCarryOver(carry);
      if (!this.question_clicked) {
        this.applyLockedSinglePrompt(true);
      }
    }

    private captureUserSwitchCarryOver(): {
      campaign: number;
      message: string;
      media: number[];
      tagSteps: { [stepId: number]: number[] };
    } {
      const controls = this.requestForm.controls;
      const wasGuest = this.requestForm.value.userStatus === 'Guestuser';
      const campaign = Number(wasGuest ? controls.externalcampaign.value : controls.campaign.value);
      const media = this.dynamicObject && Array.isArray(this.dynamicObject[Constants.storyStep.media])
        ? [...this.dynamicObject[Constants.storyStep.media]]
        : [];
      const tagSteps: { [stepId: number]: number[] } = {};
      if (this.dynamicObject) {
        Object.keys(this.dynamicObject).forEach((key) => {
          const stepId = +key;
          if (stepId === Constants.storyStep.media) return;
          const ids = this.dynamicObject[key];
          if (Array.isArray(ids) && ids.length) {
            tagSteps[stepId] = [...ids];
          }
        });
      }
      return {
        campaign: campaign > 0 ? campaign : null,
        message: (wasGuest ? controls.message.value : controls.internalmessage.value) || '',
        media,
        tagSteps
      };
    }

    private restoreUserSwitchCarryOver(carry: {
      campaign: number;
      message: string;
      media: number[];
      tagSteps: { [stepId: number]: number[] };
    }): void {
      const controls = this.requestForm.controls;
      const isGuest = this.requestForm.value.userStatus === 'Guestuser';
      if (carry.campaign && this.activePromptTab === 'campaign') {
        if (isGuest) {
          controls.externalcampaign.setValue(carry.campaign);
          this.extermalChangecampaigns(String(carry.campaign));
        } else {
          controls.campaign.setValue(carry.campaign);
          this.Changecampaigns(String(carry.campaign));
        }
      }
      if (carry.message) {
        (isGuest ? controls.message : controls.internalmessage).setValue(carry.message);
      }
    }

    // Tabbed interface methods
    public setActivePromptTab(tab: 'single' | 'campaign'): void {
      if(!this.isBrowser || this.lockChosenPrompt) return;
      
      this.activePromptTab = tab;
      
      // Reset current selections when switching tabs
      if (this.requestForm.value.userStatus === 'user') {
        this.requestForm.controls.question.setValue(-1);
        this.requestForm.controls.campaign.setValue(-1);
      } else {
        this.requestForm.controls.externalquestion.setValue(-1);
        this.requestForm.controls.externalcampaign.setValue(-1);
      }
      
      // Reset prompt container state
      this.isShowPromptContainer = false;
      this.requestForm.controls.about.setValue('');
      this.requestForm.controls.content.setValue('');
      if (tab === 'single' && !this.question_clicked) {
        this.applyLockedSinglePrompt(true);
      }
    }

    /** Header Request a Story shows both sides. A single-prompt row shows only the sides that prompt allows. */
    public showUserRequestTab(): boolean {
      if (!this.isSinglePromptRequest()) {
        return true;
      }
      return this.initialState.allowUser !== false;
    }

    public showGuestRequestTab(): boolean {
      if (!this.isSinglePromptRequest()) {
        return true;
      }
      return this.initialState.allowGuest !== false;
    }

    public showRequestAudienceToggle(): boolean {
      return this.showUserRequestTab() && this.showGuestRequestTab();
    }

    /** Opened from a Single Prompts row: the prompt stays fixed. */
    public get lockChosenPrompt(): boolean {
      return this.isSinglePromptRequest();
    }

    public get lockedPromptLabel(): string {
      const state = this.initialState;
      return (state && typeof state === 'object' && state.questionText) || '';
    }

    private isSinglePromptRequest(): boolean {
      const state = this.initialState;
      return !!(state && typeof state === 'object' && state.fromSinglePrompt);
    }

    private requesterEmail(): string {
      const state = this.initialState;
      if (state && typeof state === 'object') {
        return state.email || '';
      }
      return typeof state === 'string' ? state : '';
    }

    private applySinglePromptOpenState(): void {
      if (!this.isSinglePromptRequest()) {
        return;
      }
      this.activePromptTab = 'single';
      if (this.initialState.allowUser !== false) {
        return;
      }
      this.requestForm.controls.userStatus.setValue('Guestuser');
      this.viewmodel.inbound = true;
      this.store$.dispatch(new storyBuilderActions.SetInbound(true));
      if (this.companyId) {
        this.store$.dispatch(new storyStepActions.Load(this.companyId, true, '', false));
      }
    }

    private applyLockedSinglePrompt(force: boolean): void {
      if (!this.isSinglePromptRequest() || !this.requestForm) {
        return;
      }
      if (!force && this.activePromptTab !== 'single') {
        return;
      }
      const id = Number(this.initialState.questionId);
      if (!id || id < 0) {
        return;
      }
      const prompt = (this.questionList || []).find((item) => Number(item.id) === id);
      const isGuest = this.requestForm.value.userStatus === 'Guestuser';
      this.activePromptTab = 'single';
      const text = (prompt && prompt.question_text) || this.initialState.questionText;
      if (text) {
        this.requestForm.controls.about.setValue(text);
        this.requestForm.controls.content.setValue(text);
        this.isShowPromptContainer = true;
        this.readOnlyforTextfiled = false;
      }
      const selectedId = prompt ? prompt.id : id;
      if (isGuest) {
        this.externalquestionid = id;
        this.requestForm.controls.externalquestion.setValue(selectedId);
        this.requestForm.controls.externalcampaign.setValue(-1);
      } else {
        this.internalQuestionId = id;
        this.requestForm.controls.question.setValue(selectedId);
        this.requestForm.controls.campaign.setValue(-1);
      }
    }

    public getDropdownLabel(): string {
      if(!this.isBrowser) return '';
      return this.activePromptTab === 'single' ? 'Single prompts' : 'Campaign prompts';
    }

    public getActivePromptData(): any[] {
      if(!this.isBrowser) return [];
      
      if (this.requestForm.value.userStatus === 'user') {
        return this.activePromptTab === 'single' ? this.userQuestion : this.campaigns;
      } else {
        return this.activePromptTab === 'single' ? this.guestquestion : this.campaigns;
      
      }

    
    }

    public getActiveFormControlName(): string {
      if(!this.isBrowser) return '';
      
      if (this.requestForm.value.userStatus === 'user') {
        return this.activePromptTab === 'single' ? 'question' : 'campaign';
      } else {
        return this.activePromptTab === 'single' ? 'externalquestion' : 'externalcampaign';
      }
    }

    public getActiveDisplayField(): string {
      if(!this.isBrowser) return '';
      return this.activePromptTab === 'single' ? 'question_text' : 'title';
    }

    // The "Select option" (id -1) row stays in the source lists because the form
    // uses -1 as "nothing picked"; the dropdown just doesn't offer it. Cached per
    // source array so ng-select gets a stable reference on every change detection.
    private promptOptionsCache = new WeakMap<any[], any[]>();

    public promptOptions(list: any[]): any[] {
      if (!list) return [];
      let options = this.promptOptionsCache.get(list);
      if (!options) {
        options = list.filter(item => item && item.id != -1);
        this.promptOptionsCache.set(list, options);
      }
      return options;
    }

    // ng-select emits the picked item; the prompt handlers expect the id as a string.
    public onPromptSelect(item: any): void {
      this.onTabPromptChange(item ? String(item.id) : '-1');
    }

    public onTabPromptChange(data: any): void {
      if(!this.isBrowser) return;
      
      if (this.activePromptTab === 'single') {
        // Handle single prompt selection
        if (this.requestForm.value.userStatus === 'user') {
          this.changeData(data);
        } else {
          this.externalchangeData(data);
        }
      } else {
        // Handle campaign prompt selection
        if (this.requestForm.value.userStatus === 'user') {
          this.Changecampaigns(data);
        } else {
          this.extermalChangecampaigns(data);
        }
      }
    }

    public onPeopleSelectionChange(event: any): void {
      if(!this.isBrowser) return;
      const items = event || [];
      const ids = items.map(item => (item && item.id != null ? item.id : item));
      this.selectedPeopleIds = ids;
      this.selectedData = ids;
      (this.members || []).forEach((member) => {
        member.checked = ids.indexOf(member.id) > -1;
      });
      if (!ids.length) {
        this.showAllRequestLinks = false;
        this.requestLinksQuery = '';
      }
      this.updateData();
    }

    get selectedRequestLinks(): any[] {
      return (this.members || []).filter((member) => member && member.checked);
    }

    get filteredRequestLinks(): any[] {
      const query = (this.requestLinksQuery || '').trim().toLowerCase();
      const links = this.selectedRequestLinks;
      if (!query) {
        return links;
      }
      return links.filter((member) => {
        const name = String(member.display_name || member.displayName || '').toLowerCase();
        const email = String(member.email || '').toLowerCase();
        return name.indexOf(query) > -1 || email.indexOf(query) > -1;
      });
    }

    get visibleRequestLinks(): any[] {
      const links = this.filteredRequestLinks;
      return this.showAllRequestLinks ? links : links.slice(0, 3);
    }

    public toggleShowAllRequestLinks(): void {
      this.showAllRequestLinks = !this.showAllRequestLinks;
    }

    public removeRequestLink(person: any): void {
      if (!this.isBrowser || !person) return;
      // Keep remaining members in place — do not reload (that clears their urls).
      person.checked = false;
      person.url = null;
      person.linkCopied = false;
      this.selectedData = (this.selectedData || []).filter((id) => id !== person.id);
      this.selectedPeopleIds = [...this.selectedData];
      this.emailSendIngPayload = (this.emailSendIngPayload || []).filter(
        (payload) => payload && payload.author_email !== person.email
      );
      if (this.selectedRequestLinks.length <= 3) {
        this.showAllRequestLinks = false;
      }
      if (!this.selectedRequestLinks.length) {
        this.resetAfterAllRequestLinksRemoved();
      }
    }

    private resetAfterAllRequestLinksRemoved(): void {
      this.isCopyCode = false;
      this.hideSendanCopylinkButton = false;
      this.showAllRequestLinks = false;
      this.requestLinksQuery = '';
      this.emailSendIngPayload = [];
      this.internalUrl = false;
      this.selectedPeopleIds = [];
      this.selectedData = [];
      this.members = [];
      this.loadUserInputData.pagination.page = 1;
      this.loadMembers([]);
    }

    /**
     * Hide Copy Link UI after an edit so Create Link must be clicked again.
     * Keep story_id/url on members — the API update path needs them in old_url
     * to regenerate unique links.
     */
    private invalidateCreatedRequestLinks(): void {
      if (!this.isCopyCode) return;
      (this.members || []).forEach((member) => {
        if (!member) return;
        member.linkCopied = false;
      });
      this.isCopyCode = false;
      this.hideSendanCopylinkButton = false;
      this.showAllRequestLinks = false;
      this.requestLinksQuery = '';
      this.emailSendIngPayload = [];
      this.requestedUsers = [];
      this.requestForm.patchValue(
        { requestedUser: null, bodyCode: null },
        { emitEvent: false }
      );
    }

    public copyRequestLink(person: any, event: any): void {
      if (!this.isBrowser || !person || !person.url) return;
      const target = event && event.currentTarget ? event.currentTarget : event;
      this.copyMessage(person, target);
    }

    public onPeopleSearch(event: any): void {
      if(!this.isBrowser) return;
      // Implementation placeholder
      console.log('People search:', event);
    }

    public closeStoryBuilder(): void {
      if(!this.isBrowser) return;
      this.isShowModal = false;
      this.isshowTag = false;
      this.isShowmedia = false;
      this.resetModalWidth();
    }

   // Dropdown label visibility methods
    public onDropdownFocus(): void {
      this.isDropdownFocused = true;
    }

    public onDropdownBlur(): void {
      this.isDropdownFocused = false;
      // Reset typing state when dropdown loses focus
      this.isDropdownTyping = false;
    }

    public onDropdownSearchChange(searchTerm: string): void {
      // Hide label when user starts typing
      this.isDropdownTyping = searchTerm && searchTerm.length > 0;
    }

    openMailBox(){
      this.sendInternalmail = true;
      this.isShowModal = false;
      this.internalUrl = false;
      this.resetModalWidth();
 
    }

    backGuestStories(){
      this.showemailSection = false;
      this.showAuthorDropdown = false;
    }
    
    onAuthorToggleChange(_value: boolean) {
      const control =
        this.requestForm.value.userStatus === 'user'
          ? this.requestForm.controls.userselcted
          : this.requestForm.controls.externalUserSelcted;
      control.setValue(null);
    }

    backInternalStories(){
      this.sendInternalmail = false;
      this.internalUrl = true;
    }


    langDropdownOpen = false;

    toggleLangDropdown(event: Event) {
      event.stopPropagation();
      this.langDropdownOpen = !this.langDropdownOpen;
    }
    
    selectLanguage(lang: any, event: Event) {
      event.stopPropagation();
    
      // Update form control manually
      this.requestForm.patchValue({
        languageSelected: lang.code
      });
    
      this.langDropdownOpen = false;
    }
}
